/**
 * Top-level router wrapper. Uses createBrowserRouter (data router) so that
 * useBlocker() works in RouteHandler.
 *
 * BrowserRouter uses clean URLs (no hash). The CDN must be configured
 * to serve index.html for all paths (SPA fallback).
 */

import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router';
import RouteHandler from './RouteHandler';
import { ErrorBoundary, RouteErrorScreen } from '@/components/ErrorBoundary';

// Lazy router creation — must NOT be at module scope because
// the legacy URL redirect (redirectLegacyUrl) sets the pathname AFTER
// imports run, so the router must be created after the redirect.
let router: ReturnType<typeof createBrowserRouter> | null = null;

function getRouter() {
  if (!router) {
    router = createBrowserRouter(
      createRoutesFromElements(
        <Route path="*" element={<ErrorBoundary><RouteHandler /></ErrorBoundary>} errorElement={<RouteErrorScreen />} />
      )
    );
  }
  return router;
}

export default function AppRouter() {
  return <RouterProvider router={getRouter()} />;
}
